/**
 * @file
 */
(function ($) {
  "use strict";

  /* Carousel */
  if ($("#slider").length > 0) {
    $("#slider").carouFredSel({
      width: "100%",
      align: false,
      //items: 3,
      auto: false,
      prev: "#prev",
      next: "#next",
      items: {
        width: $("#wrapper").width() * 0.15,
        height: 500,
        visible: 1,
        minimum: 1,
      },
      scroll: {
        items: 1,
        timeoutDuration: 5000,
        onBefore: function (data) {
          //	find current and next slide
          var currentSlide = $(".slide.active", this),
            nextSlide = data.items.visible,
            _width = $("#wrapper").width();

          //	resize currentslide to small version
          currentSlide.stop().animate({
            width: _width * 0.15,
          });
          currentSlide.removeClass("active");

          //	hide current block
          data.items.old
            .add(data.items.visible)
            .find(".slide-block")
            .stop()
            .fadeOut();

          //	animate clicked slide to large size
          nextSlide.addClass("active");
          nextSlide.stop().animate({
            width: _width * 0.7,
          });
        },
        onAfter: function (data) {
          //	show active slide block
          data.items.visible.last().find(".slide-block").stop().fadeIn();
        },
      },
      onCreate: function (data) {
        //	clone images for better sliding and insert them dynamacly in slider
        var newitems = $(".slide", this).clone(true),
          _width = $("#wrapper").width();

        $(this).trigger("insertItem", [newitems, newitems.length, false]);

        //	show images
        $(".slide", this).fadeIn();
        $(".slide:first-child", this).addClass("active");
        $(".slide", this).width(_width * 0.15);

        //	enlarge first slide
        $(".slide:first-child", this).animate({
          width: _width * 0.7,
        });

        //	show first title block and hide the rest
        $(this).find(".slide-block").hide();
        $(this).find(".slide.active .slide-block").stop().fadeIn();
      },
    });

    // Handle click events
    $("#slider")
      .children()
      .click(function () {
        $("#slider").trigger("slideTo", [this]);
      });

    // Enable code below if you want to support browser resizing
    $(window).resize(function () {
      var slider = $("#slider"),
        _width = $("#wrapper").width();

      //	show images
      slider.find(".slide").width(_width * 0.15);

      //	enlarge first slide
      slider.find(".slide.active").width(_width * 0.7);

      //	update item width config
      slider.trigger("configuration", ["items.width", _width * 0.15]);
    });
  }

  $(".accessibility--control").click(function (e) {
    var accessibilityFeature = $(this).attr("data-accessibility-feature");
    var accessibilityUnit = $(this).attr("data-accessibility-unit");
    if (accessibilityFeature === "fontSize") {
      $("body").css("font-size", accessibilityUnit + "em");
    } else if (accessibilityFeature === "colourContrast") {
      $("body").removeClass("theme__soft theme__blue theme__hivis");
      $("body").addClass("theme__" + accessibilityUnit);
    }
    eraseCookie(accessibilityFeature);
    createCookie(accessibilityFeature, accessibilityUnit, 365);
  });

  var textCookie = readCookie("fontSize");
  if (textCookie) {
    $("body").css("font-size", textCookie + "em");
  }
  var contrastCookie = readCookie("colourContrast");
  if (contrastCookie) {
    $("body").addClass("theme__" + contrastCookie);
  }

  //cookie functions http://www.quirksmode.org/js/cookies.html
  function createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }
  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function eraseCookie(name) {
    createCookie(name, "", -1);
  }
  //cookie functions

  //Jvector maps
  if ($("#map").length > 0) {
    var gdpData = {};
    var slug = $("#map").data("map");

    var postid = $("#map").data("postid");
    var isocode = $("#map").data("isocode");
    if (postid) {
      $.getJSON(
        "/wp-json/cfnhri_custom_api/v1/parentID?parentID=" + postid,
        function (data) {
          console.log(data);
          gdpData = data;

          $("#map").vectorMap({
            map: slug + "_mill",
            backgroundColor: "#fff",
            zoomMax: 10,
            zoomMin: slug === "europe" ? 3 : 1,
            regionStyle: {
              initial: {
                fill: "#DEDDDD",
              },
            },
            series: {
              regions: [
                {
                  values: gdpData,
                  scale: ["#C8EEFF", "#178EC8"],
                  normalizeFunction: "polynomial",
                },
              ],
            },
            onRegionClick: function (e, code) {
              var map = $("#map").vectorMap("get", "mapObject");

              console.log(window.location.origin);
              console.log(slug);
              var name = map
                .getRegionName(code)
                .toLowerCase()
                .replace(/ /g, "-");
              if (gdpData[code] === 1) {
                window.location.replace(
                  window.location.origin + "/members/" + slug + "/" + name
                );
              }
            },
          });

          if (slug === "europe") {
            var map = $("#map").vectorMap("get", "mapObject");
            var params = { x: 0.5, y: 0.48, scale: 2 };
            map.setFocus(params);
          }
        }
      );
    } else if (isocode) {
      gdpData[isocode] = 1;
      console.log(gdpData);
      $("#map").vectorMap({
        map: slug + "_mill",
        backgroundColor: "#fff",
        regionStyle: {
          initial: {
            fill: "#DEDDDD",
          },
        },
        series: {
          regions: [
            {
              values: gdpData,
              scale: ["#C8EEFF", "#178EC8"],
              normalizeFunction: "polynomial",
            },
          ],
        },
        onRegionClick: function (e, code) {
          var map = $("#map").vectorMap("get", "mapObject");

          console.log(slug);
          var name = map.getRegionName(code).toLowerCase().replace(/ /g, "-");
          if (gdpData[code] === 1) {
            window.location.replace(
              window.location.origin + "/members/" + slug + "/" + name
            );
          }
        },
      });
    } else {
      $("#map").vectorMap({
        map: slug + "_mill",
        backgroundColor: "#fff",
        regionStyle: {
          initial: {
            fill: "#178EC8",
          },
        },
        onRegionClick: function (e, code) {
          var map = $("#map").vectorMap("get", "mapObject");

          var name = map.getRegionName(code).toLowerCase().replace(/ /g, "-");
          window.location.replace(window.location.origin + "/members/" + name);
        },
      });
    }
  }

  function showFancyBoxModal() {
    const openFancyModal = document.getElementById("open-fancybox");

    if (openFancyModal) {
      openFancyModal.addEventListener("click", function (e) {
        const content = document.getElementById("footerHSForm");
        content.innerHTML = "";
        openForm();
      });
    }
  }

  function showFancyBoxModalHeader() {
    const openFancyModalHeader = document.querySelectorAll(
      ".open-fancybox-header"
    );

    if (openFancyModalHeader) {
      openFancyModalHeader.forEach((element) => {
        element.addEventListener("click", function (e) {
          const content = document.getElementById("footerHSForm");
          content.innerHTML = "";
          openForm();
        });
      });
    }
  }

  function openForm() {
    hbspt.forms.create({
      region: "na1",
      portalId: "4351574",
      formId: "1d76c041-607e-4db7-8b83-cff65d53abec",
      target: "#footerHSForm",
    });
  }

  showFancyBoxModal();
  showFancyBoxModalHeader();

  $(window).on("load", function () {
    $(".react-add-to-calendar__button").attr("href", "#");
  });

  $(".dropdown-menu .select--option").on("keydown", function (event) {
    if (event.which === 13) {
      // Cancel the default action, if needed

      //call function, trigger events and everything tou want to dd . ex : Trigger the button element with a click
      $(this).trigger("click");
    }
  });
})(jQuery);
